import { MenuLink } from "./MenuLink.type";

export const getBooleanValue = (property: boolean | string) =>
  typeof property === "boolean" ? property : property === "true";

export function processSection(section: any): {
  id: string;
  children: MenuLink[];
} {
  const children = section["@nodes"].map((child: any) => ({
    id: section[child]["@id"],
    shouldOpenInNewWindow: getBooleanValue(section[child].openInNewWindow),
    label: section[child].label,
    link: section[child].link,
    renderAsText: getBooleanValue(section[child].isCategory),
    isVisible: getBooleanValue(section[child].isVisible),
  }));
  return { id: section["@id"], children };
}

export function processResponse(response: any): MenuLink[] {
  if (response && response["@nodes"]) {
    return response["@nodes"].map((node: any) => {
      const element = response[node];

      const x: MenuLink = {
        id: element["@id"],
        shouldOpenInNewWindow: getBooleanValue(element.shouldOpenInNewWindow),
        label: element.label,
        link: element.link,
        isVisible: getBooleanValue(element.isVisible),
      };
      if (element["@nodes"].length > 0) {
        const nodes: any[] = element["@nodes"];
        // if some nodes have children of their own it's  a sections popover
        const isSection = nodes.some(
          (node) => element[node]["@nodes"].length > 0
        );
        if (isSection) {
          x.sections = nodes.map((node) => {
            const section = element[node];
            return processSection(section);
          });
        }

        if (!isSection) {
          x.children = nodes.map((node) => {
            const child = element[node];

            return {
              id: child["@id"],
              shouldOpenInNewWindow: getBooleanValue(
                child.shouldOpenInNewWindow
              ),
              label: child.label,
              link: child.link,
              isVisible: getBooleanValue(child.isVisible),
            };
          });
        }
      }
      return x;
    });
  }
  return [];
}
